module.exports = __webpack_public_path__ + "static/media/ArrowUp.28533fb0.svg";